const CUSTOMER_DISPLAY_MAIN_APP_PRESENCE_LOCK =
  'customer-display-main-app-presence'

const getLockManager = () => globalThis.navigator?.locks
const getPresenceLockName = tabId =>
  tabId
    ? `${CUSTOMER_DISPLAY_MAIN_APP_PRESENCE_LOCK}:${tabId}`
    : CUSTOMER_DISPLAY_MAIN_APP_PRESENCE_LOCK

export const acquireCustomerDisplayMainAppPresence = tabId => {
  const lockManager = getLockManager()
  const lockName = getPresenceLockName(tabId)
  if (typeof lockManager?.request !== 'function') return null

  let releaseLock
  let released = false
  const releasePromise = new Promise(resolve => {
    releaseLock = resolve
  })

  lockManager
    .request(lockName, { mode: 'shared' }, async () => {
      if (released) return
      await releasePromise
    })
    .catch(error => {
      console.warn(
        'No se pudo registrar la presencia de la app principal:',
        error
      )
    })

  return () => {
    if (released) return

    released = true
    releaseLock()
  }
}

export const hasCustomerDisplayMainAppPresence = async tabId => {
  const lockManager = getLockManager()
  const lockName = getPresenceLockName(tabId)
  if (typeof lockManager?.query !== 'function') return null

  try {
    const { held = [] } = await lockManager.query()
    return held.some(lock => lock.name === lockName)
  } catch (error) {
    console.warn('No se pudo validar la presencia de la app principal:', error)
    return null
  }
}
